// 用户管理
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" @resetEvent="resetEvent" :_dataId.sync="dataId"
                  :parent-target="_self" @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="display:flex">
          <!-- 左边------- 树型结构 -->
          <div class="left" ref="refLeft">

            <div style="padding: 5px;margin: 0px 8px;    max-height: 70vh; overflow: hidden;overflow-y: scroll;border: 1px solid #ededed;">
              <div class="title">
                <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
                     version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
                  <path
                    d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
                    fill="#1296db" p-id="2888"></path>
                </svg>

                <span>用户管理</span>
              </div>
              <el-input placeholder="关键字过滤" v-model="filterText">
              </el-input>

              <el-tree class="tree-line" :data="data" lazy :load="loadChildNode" :props="defaultProps"
                       @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree">
              </el-tree>
            </div>
          </div>


          <div class="center"
	ref="refCenter"
	@mousedown.stop.prevent="startResize">⋮</div>



          <div class="table_main right" ref="refRight" style="height: calc(100vh - -30px);">
            <vxe-grid ref="table-m1" show-overflow height="100%" :stripe="true" border="default"
                      :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">

              <template #form>
                <div class="clearfix screen-btns">
                  <div class="fl">
                    <vxe-button v-if="userAdd" status="primary" class="button-sty" icon="el-icon-plus"
                                @click="openEditDialog">新增
                    </vxe-button>
<!--                    <vxe-button status="primary" class="button-sty" icon="el-icon-bottom" v-if="sysUserImport"-->
<!--                                @click="$refs.excelUpload.show()">导入-->
<!--                    </vxe-button>-->
                    <vxe-button v-if="userAdd" status="primary" class="button-sty" icon="el-icon-top"
                                @click="$refs.excelUpload.show()">导入
                    </vxe-button>
<!--                    <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"-->
<!--                                @click="openEditDialog">导出-->
<!--                    </vxe-button>-->
<!-- <vxe-button
class="button-sty"
                plain
                type="primary"
                size="small"
                icon="el-icon-upload"
                @click="$refs.excelUpload.show()"
              >导入
              </vxe-button>
              <vxe-button
              class="button-sty"
                plain
                type="primary"
                size="small"
                icon="el-icon-download"
                @click="exportExcel"
              >导出
              </vxe-button> -->
                  </div>
                  <div class="fr">
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索
                    </vxe-button>
                  </div>
                </div>
                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="用户名:" field="brandName">
                    <template v-slot>
                      <el-input v-model="formData.username" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="姓名:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.name" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="手机号:" field="phone">
                    <template v-slot>
                      <el-input v-model="formData.phone" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="角色:" field="role">
                    <template v-slot>
                      <RoleSearch :role-id.sync="formData.roleId" style="width:9vw ;" />
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
              <template #postList="{ row }">
                <span class="txt-status2" v-for="item in row.postList" :key="item.postName">{{ item.postName }}</span>
              </template>
              <template #roleList="{ row }">
                <span class="txt-status2" v-for="item in row.roleList" :key="item.id">{{ item.roleName }}</span>
              </template>
            </vxe-grid>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
            <!--excel 模板导入 -->
            <excel-upload
          ref="excelUpload"
          title="用户信息导入"
          url="/admin/user/import"
          temp-url="/admin/sys-file/local/file/user.xlsx"
          @refreshDataList="refreshChange"
        ></excel-upload>
  </div>
</template>

<script>
import editView from './edit.vue';
import {indexPageMixins} from '@/mixins/tabChang'
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import {addObj, delObj, fetchList, putObj} from "@/api/admin/user";

import ExcelUpload from "@/components/upload/excel";
import RoleSearch from "@/components/formItem/roleSearch.vue";



export default {
  name: 'user',
  mixins: [indexPageMixins],

  components: {editView, pager, ExcelUpload,RoleSearch},
  data() {
    return {
      excelUpload: false,
      searchForm: {},

      //权限控制
      userAdd: false,
      userEdit: false,
      userUnlock: false,
      sysUserImport:false,

      total: 0,
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      // 查询参数
      formData: {
        current: 1,
        searchCount: false,
        // parentId: undefined,
        brandName: "",
        deptId: '',
        id: '',
        username:'',
        name:null,
        phone:null,
        roleId:null
      },
    };
  },
  mounted() {
    // this.initTableList();
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
  },
  created() {
    this.userAdd = this.permissions["sys_user_add"];
    this.userEdit = this.permissions["sys_user_edit"];
    this.userUnlock = this.permissions["sys_user_unlock"];
    this.sysUserImport = this.permissions['sysUserImport']
  },
  methods: {
            // 左右拖动这里的一个大概说明，就是把减少的div宽度，加到另一个div的宽度上去，就是现实一增一减；变量自己取data定义就行了，
            startResize(event) {
      this.startX = event.clientX;
      this.startWidth = this.$refs.refRight.offsetWidth;
      console.log(event.clientX,this.startWidth,'this.startWidth')
      this.isResizing = true;
 
      window.addEventListener('mousemove', this.doResize);
      window.addEventListener('mouseup', this.stopResize);
    },
    doResize(event) {
      if (this.isResizing) {console.log(event.clientX,'this.startWidth')
        const deltaX = -event.clientX + this.startX;
        this.$refs.refRight.style.width = this.startWidth + deltaX + 'px';
      }
    },
    stopResize() {
      this.isResizing = false;
      window.removeEventListener('mousemove', this.doResize);
      window.removeEventListener('mouseup', this.stopResize);
    },
    toFilterData() {
            this.searchEvent();
     },
    // 导出
    exportExcel() {
      this.downBlobFile("/admin/user/export", this.searchForm, "user.xlsx");
    },
    // 导入
    getList(page, params) {
      this.listLoading = true;
      fetchList(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize
          },
          params,
          this.searchForm
        )
      ).then(response => {
        this.list = response.data.data.records;
        console.log('list:值是？？？？？？？？？', this.list)
        this.page.total = response.data.data.total;
        this.listLoading = false;
      });
    },
    refreshChange() {
      this.getList(this.page);
    },

    // el-tab 监视切换事件
    handleClick(tab, event) {
      console.log(tab, event);
    },

    // 分页功能
    changeTablePage(page, flag) {
      console.log('分页数据', page, this.formData)
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.getTableData();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 搜索
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.$refs['table-m1'].commitProxy('reload');
    },
    // 重置
    resetEvent() {
      this.formData = {};
      this.formData.addresswangdian = {};
      this.$refs.pager.reset()  // 重置分页器
      this.$refs['table-m1'].commitProxy('reload');
    },
    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    deletes(id) {
      console.log(id, "删除所选的ID");
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: '/admin/user/' + id,
          method: `delete`,
        }).then(() => {
          this.$message.success("删除成功！");
          this.getTableData()
          this.$mask.close()
        }).catch(e => {
          this.$mask.close()
        })

      })
    },
    // 点击的树形 点
    handleNodeClick(node, data) {
      console.log(data, "点击data的值");
      let id = data.data.id;
      console.log(id, "点击id的值");
      if (data.level === 1) {
        this.formData.deptId = id;
      } else {
        this.formData.deptId = id;
      }

      console.log(this.formData, "this.formData的值");
      this.getTableData();

      this.$refs['table-m1'].commitProxy('reload');

    },

    getTableData() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: '/admin/user/page',
        param: this.formData,
        method: 'get',

        columns: [
          {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
          { title: '用户名', field: 'username', width: 120,},
          { title: '姓名', field: 'name', width: 120, },
          { title: '岗位', field: 'postList', width: 150, slots: {default: 'postList'}},
          { title: '角色', field: 'roleList', width: 180, slots: {default: 'roleList'}},
          { title: '状态', field: 'lockFlag', width: 120, slots: {
              default: ({row}) => {
                if (row.lockFlag == 0) {
                  return [
                    <div class="txt-status">
                      <span>有效</span>
                    </div>
                  ];
                } else if (row.lockFlag == 1) {
                  return [
                    <div class="txt-status  disable">
                      <span>锁定</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '是否禁用', field: 'delFlag', width: 120, slots: {
              default: ({row}) => {
                if (row.delFlag == 0) {
                  return [
                    <div class="txt-status">
                    <span>否</span>
                    </div>
                ];
                } else if (row.delFlag == 1) {
                  return [
                    <div class="txt-status  disable">
                    <span>是</span>
                    </div>
                ];
                }
              }
            }
          },
          { title: '手机号', field: 'phone', width: 120,},
          { field: 'createDate', title: '创建时间', width: 180},
          { width: 90, fixed: 'right', title: '操作', sortable: false, slots: {
              default: ({row}) => {
                if (this.userEdit && this.userUnlock && row.lockFlag === 9) {
                  return [
                    <div>
                      <a
                        href="javascript:void(0);"
                        class="a-link"
                        onclick={() => {
                          this.openEditDialog(row.id);
                        }}
                      >
                        <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-edit"/>
                        </el-tooltip>
                      </a>
                    <a
                  href="javascript:void(0);"
                class="a-link"
                  onclick={() => {
                    this.doUnlock(row.id,row.username);
                  }}
                >
                <el-tooltip enterable={false} effect="dark" content="解锁" placement="top"
                  popper-class="tooltip-skin">
                    <i class="el-icon-unlock"/>
                    </el-tooltip>
                    </a>
                    </div>
                  ];
                } else if (this.userEdit) {
                  return [
                    <div>
                    <a
                  href="javascript:void(0);"
                class="a-link"
                  onclick={() => {
                    this.openEditDialog(row.id);
                  }}
                >
                <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                  popper-class="tooltip-skin">
                    <i class="el-icon-edit"/>
                    </el-tooltip>
                    </a>
                    </div>
                ];
                }else if (this.userUnlock && row.lockFlag === 9) {
                  return [
                    <div>
                    <a
                  href="javascript:void(0);"
                class="a-link"
                  onclick={() => {
                    this.doUnlock(row.id,row.username);
                  }}
                >
                <el-tooltip enterable={false} effect="dark" content="解锁" placement="top"
                  popper-class="tooltip-skin">
                    <i class="el-icon-unlock"/>
                    </el-tooltip>
                    </a>
                    </div>
                ];
                }
              }
            }
          }
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载页面
    loadChildNode(node, resolve) {
      console.log(node, "loadChildNode.node")
      this.$http.post(api.userTree.getTree, {
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        console.log(data, "data.data的值")
        resolve(
          data.data.map(item => {
            return {
              label: item.name,
              id: item.id,
              leaf: Number(item.hasChild) == 1 ? false : true,
            }
          })
        )
      });
    },
  //解锁
    doUnlock(id,username){
      this.$baseConfirm('您确定要解锁当前用户吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: '/admin/user/unlock',
          method: `post`,
          data: {
            id:id,
            username:username
          }
        }).then(() => {
          this.$message.success("解锁成功！");
          this.getTableData()
          this.$mask.close()
        }).catch(e => {
          this.$mask.close()
        })
      })
    },
  }
};
</script>
<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

// .table_main {
//   padding-top: 5px;
//   padding-left: 5px;
//   border: 1px solid #ededed;
//   width: calc(100% - 215px);
//   border-bottom: none;

//   .el-pagination {
//     padding: 2px;

//   }
// }

.left_tree {


  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep .vxe-grid .a-link {
  margin-right: -3px !important;
}

.left {
      flex: 1;
      height: 100%;
      min-width: 250px;
      // width:600px
    }
    .center {
      cursor: col-resize;//拖动鼠标样式
      height: 100%;
      width: 8px;

      cursor: col-resize;
  // position: relative;
  // top: 45%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: 150px;
  margin-right: 5px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  font-size: 32px;
  color: white;
    }
    .right {
      // width: calc(100% - 600px);
      min-width: calc(100% - 600px);
      height: 100%;
    }
</style>

